// Paving Traders Theme JS
// Hero Slider
var slideIdx=0,autoTimer;
function goSlide(n){
  var slides=document.querySelectorAll('.hero-slide');
  var dots=document.querySelectorAll('.hero-dot');
  if(!slides.length)return;
  slides.forEach(function(s,i){s.classList.toggle('active',i===n)});
  dots.forEach(function(d,i){d.classList.toggle('active',i===n)});
  slideIdx=n;
}
function nextSlide(){var slides=document.querySelectorAll('.hero-slide');if(slides.length)goSlide((slideIdx+1)%slides.length);}
function prevSlide(){var slides=document.querySelectorAll('.hero-slide');if(slides.length)goSlide((slideIdx+slides.length-1)%slides.length);}
function startAuto(){autoTimer=setInterval(nextSlide,5000);}
function stopAuto(){clearInterval(autoTimer);}
var hs=document.getElementById('heroSlider');
if(hs){hs.addEventListener('mouseenter',stopAuto);hs.addEventListener('mouseleave',startAuto);startAuto();}

// Cart Drawer (used on collection grid pages - unchanged)
var cartOverlay=document.getElementById('cartOverlay');
var cartDrawer=document.getElementById('cartDrawer');
var cartToggle=document.getElementById('cartToggle');
if(cartToggle)cartToggle.addEventListener('click',openCart);
document.querySelectorAll('#cartClose,#cartClose2,.cart-drawer-close').forEach(function(b){if(b)b.addEventListener('click',closeCart)});
if(cartOverlay)cartOverlay.addEventListener('click',closeCart);
function openCart(){
  if(cartOverlay)cartOverlay.classList.add('open');
  if(cartDrawer)cartDrawer.classList.add('open');
  loadCart();
}
function closeCart(){
  if(cartOverlay)cartOverlay.classList.remove('open');
  if(cartDrawer)cartDrawer.classList.remove('open');
}
function loadCart(){
  fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
    var body=document.getElementById('cartDrawerBody');
    var sub=document.getElementById('cartSubtotal');
    var count=document.getElementById('cart-count');
    if(count)count.textContent=cart.item_count;
    if(sub)sub.textContent=formatMoney(cart.total_price);
    if(!body)return;
    if(cart.item_count===0){body.innerHTML='<div class="cart-empty">Your basket is empty</div>';return;}
    var html='';
    cart.items.forEach(function(item){
      console.log("item", item);

      var propertiesHtml='';

      if(item.properties){
        Object.keys(item.properties).forEach(function(key){
          if(key.indexOf('_')===0)return;

          var value=item.properties[key];
          if(!value)return;

          propertiesHtml+='<div class="cart-item-property">'
            +'<span>'+key.trim()+':</span> '
            +value
            +'</div>';
        });
      }

      html+='<div class="cart-item">'
        +'<img class="cart-item-img" src="'+item.image+'" alt="'+item.title+'">'
        +'<div class="cart-item-info">'
          +'<div class="cart-item-name">'+item.title+'</div>'
          +propertiesHtml
          +'<div class="cart-item-price">'+formatMoney(item.final_price)+'</div>'
        +'</div>'
        +'<button class="cart-item-rm" onclick="removeItem(\''+item.key+'\')">&times;</button>'
        +'</div>';
    });
    body.innerHTML=html;
  }).catch(function(){});
}

// addToCart: unchanged behaviour. When openAfter=true, opens the SIMPLE DRAWER.
// This is used by the collection grid "Add to Cart" buttons.
function addToCart(variantId,qty,openAfter){
  qty=qty||1;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:variantId,quantity:qty})})
  .then(function(r){return r.json()}).then(function(item){
    showToast((item.title||'Product')+' added to basket');
    updateCartCount();
    if(openAfter)openCart();
  }).catch(function(){showToast('Added to basket');});
}

// addToCartWithModal: NEW function used ONLY by the product page (PDP)
// "ADD TO BASKET" button. Instead of opening the simple drawer, it opens
// the East-style confirmation modal (with upsell carousel) defined in
// snippets/product-added-modal.liquid.
function addToCartWithModal(variantId,qty){
  qty=qty||1;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:variantId,quantity:qty})})
  .then(function(r){return r.json()}).then(function(item){
    updateCartCount();
    if(typeof openProductAddedModal==='function'){
      openProductAddedModal(variantId, qty, item);
    }else{
      // Fallback: if the modal snippet isn't present on this page for some
      // reason, don't break the add-to-cart action - just show a toast.
      showToast((item.title||'Product')+' added to basket');
    }
  }).catch(function(){showToast('Added to basket');});
}

function removeItem(lineItemKey){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:lineItemKey,quantity:0})})
  .then(function(){loadCart();updateCartCount();}).catch(function(){});
}
function updateCartCount(){
  fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
    var c=document.getElementById('cart-count');
    if(c)c.textContent=cart.item_count;
  }).catch(function(){});
}
function formatMoney(cents){return '\u00a3'+(cents/100).toFixed(2);}

// Toast
function showToast(msg){
  var t=document.getElementById('toast');
  if(!t)return;
  t.textContent=msg;t.classList.add('show');
  clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('show');},3000);
}

// Tabs
function swTab(btn,paneId){
  var wrap=btn.closest('.pdp-info')||btn.closest('section')||document;
  wrap.querySelectorAll('.tab-btn').forEach(function(b){b.classList.remove('active')});
  wrap.querySelectorAll('.tab-pane').forEach(function(p){p.classList.remove('active')});
  btn.classList.add('active');
  var p=document.getElementById(paneId);
  if(p)p.classList.add('active');
}

// PDP
function swapImg(imgId,src,thumb){
  var img=document.getElementById(imgId);
  if(img)img.src=src;
  if(thumb){var gallery=thumb.closest('.pdp-gallery');if(gallery){gallery.querySelectorAll('.pdp-thumb').forEach(function(t){t.classList.remove('active')});thumb.classList.add('active');}}
}
function selectVariant(btn, variantId, price) {
  var row = btn.closest('.size-btns');
  if (row) row.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('active') });
  btn.classList.add('active');

  // Update the main price display
  var priceEl = document.querySelector('.pdp-m2-price');
  if (priceEl) priceEl.innerHTML = price + ' <small>Including Vat</small>';

  // Update the packs total
  var qty = parseInt(document.getElementById('pdpQty').value) || 1;
  var numericPrice = parseFloat(price.replace(/[^0-9.]/g, ''));
  var totalEl = document.getElementById('pdpTotal');
  if (totalEl) totalEl.textContent = '£' + (numericPrice * qty).toFixed(2);

  // Update add to cart button - now wires to the modal version
  var addBtn = document.getElementById('pdpAddBtn');
  if (addBtn) addBtn.onclick = function() { addToCartWithModal(variantId, parseInt(document.getElementById('pdpQty').value)) };
}
function chgQtyPDP(delta){
  var input=document.getElementById('pdpQty');
  if(!input)return;
  var val=Math.max(1,(parseInt(input.value)||1)+delta);
  input.value=val;
}

// Area Calculator
function calcArea(){
  var l=parseFloat(document.getElementById('calc-l').value)||0;
  var w=parseFloat(document.getElementById('calc-w').value)||0;
  var price=parseFloat(document.getElementById('calc-mat').value)||21;
  var area=l*w*1.1;
  var aEl=document.getElementById('calc-area');
  var pEl=document.getElementById('calc-price');
  if(aEl)aEl.textContent=area.toFixed(1);
  if(pEl)pEl.textContent='\u00a3'+(area*price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
}

// FAQ
function toggleFaq(el){
  var open=el.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(function(x){x.classList.remove('open')});
  if(!open)el.classList.add('open');
}

// Filter
function setFilter(el){
  var bar=el.closest('.filter-bar');
  if(bar)bar.querySelectorAll('.filter-btn').forEach(function(b){b.classList.remove('active')});
  el.classList.add('active');
}